import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Step3 = ({ handleChange, handleSubmit, values, setStep, step }) => {
  const [token, setToken] = useState("");
  const siteKey = "6LdTYnknAAAAAEUBgCdOjFC3jEBb6iOldVjBdMCt";

  const handleCaptchaChange = (reCaptchaToken) => setToken(reCaptchaToken);

  return (
    <div className="w-auto">
      <h2 className="text-3xl text-sky-700 font-medium capitalize mb-8 mt-16">
        Please provide the information below:
      </h2>
      <form
        className="w-full text-start"
        onSubmit={(e) => {
          if (token) {
            handleSubmit(e);
          } else {
            e.preventDefault();
            alert("Please verify that you are not a robot.");
          }
        }}
      >
        <div className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 mb-8">
          <div className="relative">
            <label
              htmlFor="first-name"
              className="text-sm font-bold text-green-700 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              First Name*
            </label>
            <input
              className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-green-700 focus:outline-none focus:shadow-outline"
              value={values.firstName}
              onChange={handleChange}
              name="firstName"
              id="firstName"
              type="text"
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="last-name"
              className="text-sm font-bold text-green-700 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Last Name*
            </label>
            <input
              className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-green-700 focus:outline-none focus:shadow-outline"
              value={values.lastName}
              onChange={handleChange}
              name="lastName"
              id="lastName"
              type="text"
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="email"
              className="text-sm font-bold text-green-700 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Email Address*
            </label>
            <input
              className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-green-700 focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              value={values.email}
              autoComplete="email"
              type="email"
              name="email"
              id="email"
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="phone"
              className="text-sm font-bold text-green-700 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Phone Number*
            </label>
            <input
              className="transition border-2 rounded py-2 px-3 w-full text-black focus:border-green-700 focus:outline-none focus:shadow-outline"
              onChange={handleChange}
              value={values.phone}
              type="number"
              name="phone"
              id="phone"
              required
            />
          </div>
          <div className="relative">
            <ReCAPTCHA onChange={handleCaptchaChange} sitekey={siteKey} />
          </div>
        </div>

        <div className="flex items-center justify-center gap-3">
          <button
            className="transition bg-green-700 hover:bg-green-800 px-16 text-white font-bold py-2 rounded border-radius-5"
            onPress={() => setStep(step - 1)}
          >
            Previous
          </button>
          <button
            className="transition bg-green-700 hover:bg-green-800 px-16 text-white font-bold py-2 rounded border-radius-5"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Step3;
